import moment from "moment"


export const ts = () => {
    return moment().format('YYYY-MM-DD  h:mm:ss')
}

export const validatePhoneNumber = (phone) => {
    const phoneRegex = /^\d{10}$/;
    return phoneRegex.test(phone);
};